import { FC } from 'react';
import { path } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { Forbidden } from '../Forbidden';
import { ClassifierForm } from './form/ClassifierForm';
import {
  checkLockOnPage,
  ObjectType,
  PermissionCode,
  Spinner,
  useGetClassifierQuery,
  useHasPermission,
  useObjectLockQuery,
  useQueryParams,
} from '@atlas-frontend/sdk';
import { useNumericParam } from '../../common/useEntityIdParam';
import { NotFound } from '../NotFound';

export const ClassifierEdit = () => {
  const classifierId = useNumericParam('id');
  const hasPermission = useHasPermission(PermissionCode.CLASSIFIER_MANAGE);

  if (!classifierId) {
    return <NotFound />;
  }

  return (
    <Forbidden isAllowed={hasPermission}>
      <ClassifierEditInner classifierId={classifierId} />
    </Forbidden>
  );
};

const ClassifierEditInner: FC<{ classifierId: number }> = (props) => {
  const { classifierId } = props;
  const [{ segment = 'categories' }] = useQueryParams();
  const { data, isLoading } = useGetClassifierQuery(classifierId);
  const { data: lockData } = useObjectLockQuery({
    objectId: classifierId,
    objectType: ObjectType.Classifier,
  });
  const navigateToClassifierView = useNavigateTo(path.classifierView, {
    id: classifierId,
  });
  const navigateToClassifierViewSegment = () =>
    navigateToClassifierView({ segment });
  checkLockOnPage(lockData, navigateToClassifierViewSegment);

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    return null;
  }

  return (
    <ClassifierForm
      mode="edit"
      id={classifierId}
      defaultValues={data}
      onClickCancel={navigateToClassifierViewSegment}
    />
  );
};
